
import FormCreatePack from "../../components/Forms/FormCreatePack";

function PackCreate() {

    return (
        <div>
            <FormCreatePack />
        </div>
    )
}

export default PackCreate;